import { render } from "./CrepesMenuSection.vue?vue&type=template&id=1aad1a17&scoped=true"
import script from "./CrepesMenuSection.vue?vue&type=script&lang=js"
export * from "./CrepesMenuSection.vue?vue&type=script&lang=js"

import "./CrepesMenuSection.vue?vue&type=style&index=0&id=1aad1a17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aad1a17"]])

export default __exports__